import { useContext, useState } from "react";
import { useFormik } from "formik";
import FormLabel from "../../../UI/Form/FormLabel";
import ButtonLoading from "../../../UI/Button/ButtonLoading";
import Alert from "../../../UI/Alert/Alert";
import { NotifyContext } from "../../../context/notifyContext";
import UserAPI from "../../../services/api/UserService";
import { Parent } from "../../../Types/Users";

interface RejectParentProps {
  onClose?: () => void;
  parent?: Parent | null;
}

export default function RejectParent(props: RejectParentProps) {
  const { parent } = props;

  const notify = useContext(NotifyContext);

  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      reason: "",
    },
    onSubmit: (values) => {
      setLoading(true);
      if (parent)
        UserAPI.reject_user(parent.user_id)
          .then((data) => {
            notify("Vous avez rejeté la demande du parent");
            setError("");
            if (props.onClose) {
              props.onClose();
            }
          })
          .catch((error) => {
            setError(error);
            notify(error, "error");
          })
          .finally(() => {
            setLoading(false);
          });
    },
  });

  return (
    <div>
      <form className="px-4 py-3" onSubmit={formik.handleSubmit}>
        {error && <Alert color="error">{error}</Alert>}

        <div className={`mt-6 `}>
          <FormLabel htmlFor="reason">
            Voulez-vous rejeter la demande de{" "}
            <strong>
              {parent?.first_name} {parent?.last_name}
            </strong>{" "}
            comme parent ?
          </FormLabel>
          <p className="text-sm text-gray-600 mt-2">
            Cette action ne peut pas être annulée. L'utilisateur sera notifié du rejet de sa demande.
          </p>
        </div>

        <div className="flex gap-3 mt-4">
          <ButtonLoading
            type="submit"
            loading={loading}
            label="Je rejette"
            className="bg-red-600 hover:bg-red-700"
          />
          <button
            type="button"
            onClick={props.onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
}
